import Config from 'Config';
import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';

/**
 * One signed 3-API request of the camera routes (camera-feeds plan, section
 * 3.4). Camera bodies carry the camera's UID and password and view-session
 * answers carry a viewing token, so nothing here logs a request, a response
 * or an axios error (whose `config` holds the body).
 */
export const cameraApiRequest = async ({
  method,
  apiPath,
  body,
  activeEmployerInfo = {},
}) => {
  const { activeEmployerId, activeEmployerBusinessId } = activeEmployerInfo;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method,
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      ...(body !== undefined && { 'Content-Type': 'application/json' }),
      ...(activeEmployerId && { 'X-Active-Employer-Id': activeEmployerId }),
      ...(activeEmployerBusinessId && {
        'X-Active-Employer-Business-Id': activeEmployerBusinessId,
      }),
    },
    ...(body !== undefined && {
      body: JSON.stringify(body), // aws4 looks for body; axios for data
      data: body,
    }),
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};

/**
 * What a failed camera request tells the UI: the HTTP status and the API's
 * `{ code, message }`, never the request.
 */
export const toCameraApiError = (error) => ({
  status: error?.response?.status ?? null,
  code: error?.response?.data?.code ?? null,
  message: error?.response?.data?.message ?? null,
});
